import React from 'react';
import * as PropTypes from 'prop-types';
import { Link, useHistory } from 'react-router-dom';

const stopPropagationOnClick = evt => {
  evt.stopPropagation();
};

const LinkWithDisabled = ({
  children,
  to,
  disabled,
  stopPropagation,
  ...props
}) => {
  const history = useHistory();
  if (disabled || history.location.pathname === to) {
    return <span>{children}</span>;
  }
  return (
    <Link
      onClick={stopPropagation ? stopPropagationOnClick : undefined}
      to={to}
      {...props}
    >
      {children}
    </Link>
  );
};

LinkWithDisabled.propTypes = {
  children: PropTypes.node,
  to: PropTypes.string,
  disabled: PropTypes.bool,
  stopPropagation: PropTypes.bool,
};

export default LinkWithDisabled;
